<mat-chip-set>
  <mat-basic-chip role="status" [ngClass]="badgeClasses">
    {{ text().replaceAll('_', ' ') | titlecase }}
  </mat-basic-chip>
</mat-chip-set>
